var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import graphQLClient from './graphql-client';
import { ANALYTICS_MUTATION, ANALYTICS_BEHAVIOR_MUTATION, } from 'graphql/mutations';
import formatISO from 'date-fns/formatISO';
const analyticsPlugin = () => ({
    name: 'seedtrace-analytics-plugin',
    // callback for triggering page view. We send user data to our server when user loads page
    page: ({ payload }) => {
        const { properties: { productId, byQr = '', sessionId, visitorId }, } = payload;
        const input = {
            visitorId,
            productId,
            sessionId,
            timestamp: formatISO(Date.now()),
            eventPayload: { byQr },
        };
        graphQLClient.request(ANALYTICS_MUTATION, { input });
    },
    // callback for tracking event. We send event to our server
    track: ({ payload }) => {
        const { event } = payload, _a = payload.properties, { visitorId, productId, sessionId } = _a, props = __rest(_a, ["visitorId", "productId", "sessionId"]), { meta: { ts } } = payload;
        const input = {
            visitorId,
            productId,
            sessionId,
            eventType: event,
            timestamp: formatISO(ts),
            eventPayload: Object.assign({}, props),
        };
        graphQLClient.request(ANALYTICS_BEHAVIOR_MUTATION, { input });
    },
    loaded: () => true,
});
export default analyticsPlugin;
